const IS_CLIENT = typeof window !== 'undefined'

// 无法兼容 server（依赖了模块执行），手动区分兼容
export default IS_CLIENT ? require('./client').default : require('./server')
